
<div
  class="status-card"
  :class="cardClasses"
  :style="cardStyle"
  :aria-label="ariaLabel"
  :data-testid="dataTestid"
  :role="role"
>
  <div v-if="$slots.icon || icon" class="status-card__icon">
    <slot name="icon">
      <v-icon :style="{ color: iconColor }" :size="iconSize">{{ icon }}</v-icon>
    </slot>
  </div>
  <div class="status-card__content">
    <slot>
      <div v-if="title" class="status-card__title">{{ title }}</div>
      <div v-if="message" class="status-card__message">{{ message }}</div>
    </slot>
  </div>
  <div v-if="$slots.actions" class="status-card__actions">
    <slot name="actions"></slot>
  </div>
</div>
